import { NgModule } from '@angular/core';
import { EntityDataService, EntityServices } from '@ngrx/data';
import { DeviceDefinitionRepository } from "./impl/service/repository/deviceDefinition.repository";
import { DeviceDefinitionDataService } from "./impl/service/repository/deviceDefinition.dataservice";

@NgModule({
})
export class DeviceDefinitionModule {
  constructor(
    entityDataService: EntityDataService,
    entityServices: EntityServices,
    repository: DeviceDefinitionRepository,
    dataService: DeviceDefinitionDataService
  ) {
    entityDataService.registerServices({
      DeviceDefinition: dataService,
    });
    entityServices.registerEntityCollectionServices({
      DeviceDefinition: repository,
    });
  }
}

